import Box from '@mui/material/Box';
import useNRQuery from '../../../graphql/useNRQuery';
import { GET_LICENSE } from '../../../graphql/queries/license';
import NRLicenseDetails from './NRLicenseIssueDetails';
import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';
import { useTheme } from '@mui/styles';
import Stack from '@mui/material/Stack';
import NRMetricCard from '../../NRMetricCard/NRMetricCard';
import NRLicenseIssuesIconX from '../../../NRIcons/NRLicenseIssuesIconX';
import { useContext, useEffect, useState } from 'react';
import { getSeverityColor } from '../../../utils/palette.utils';
import NRDrawerTile from './NRDrawerTile';
import { CONSTANTS } from '../../../constants/constants';
import { FiltersContext } from '../../../pages/NRReportTabs/NRReportFilterContextWrapper';
import { encodeParam } from '../../../services/params.utils';
import { removeTabAndSubTabFromFilePath } from '../../../services/urlInterceptor.utils';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
const { EQUAL, CONTAINS } = CONSTANTS.FILTER_OPERATIONS;

function NRLicenseDrawerContainer({ spdxId }) {
  const theme = useTheme();
  const { componentId } = useParams();
  const { setOpenDrawer } = useContext(FiltersContext);
  const [, setSeverityColor] = useState();
  const [redirectToParams, setRedirectToParams] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const [license, isLoading, _, tot, called] = useNRQuery({
    query: GET_LICENSE,
    options: {
      context: { version: 'v3' },
      fetchPolicy: 'no-cache',
      variables: {
        args: {
          spdxId: spdxId || 'test',
          assetId: componentId
        }
      }
    },
    qlObjKey: 'license',
    transformData: data => {
      if (data) {
        setSeverityColor(getSeverityColor('medium' /*data.severity*/, theme));
      }
      return data;
    }
  });

  const handleTotalIssuesClick = () => {
    let extraParams = new URLSearchParams();
    extraParams.append(
      'licenseIssuesColumnFilter',
      encodeParam([
        {
          fieldName: 'LICENSE',
          value: spdxId,
          operation: CONTAINS.toUpperCase()
        }
      ])
    );
    setRedirectToParams({ extraParams, tab: CONSTANTS.REPORT.TABS.LICENSE_ISSUES });
    setOpenDrawer(false);
  };

  useEffect(() => {
    !!redirectToParams &&
      !!redirectToParams?.extraParams &&
      navigate(`${removeTabAndSubTabFromFilePath(location)}/${redirectToParams.tab}?${redirectToParams.extraParams.toString()}`);
  }, [redirectToParams]);

  const handleTotalComponentsClick = () => {
    let extraParams = new URLSearchParams();
    extraParams.append(
      'componentColumnFilter',
      encodeParam([
        {
          fieldName: 'LICENSE',
          value: spdxId,
          operation: EQUAL.toUpperCase()
        }
      ])
    );
    setRedirectToParams({ extraParams, tab: CONSTANTS.REPORT.TABS.SBOM });
    setOpenDrawer(false);
  };

  return (
    <Box
      id={'license-details-main-container'}
      sx={{ height: '100%', maxHeight: 'calc(100vh - 176px)', overflowY: 'auto', padding: theme.spacing(3, 3, 6) }}
    >
      {!isLoading && !!called && !!license && (
        <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} gap={theme.spacing(2)}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <NRMetricCard
              maxWidth={'48%'}
              metric={'License'}
              result={license.licenseName}
              icon={<NRLicenseIssuesIconX height={theme.spacing(4)} width={theme.spacing(4)} color={theme.palette.text.iconInfo} />}
              caption={`${license?.licenseType}`}
            />
            {/*<NRMetricCard
              metric={'Issues'}
              result={license.issuesCount || '3 for testing'}
              icon={<WarningAmberOutlinedIcon sx={{ width: theme.spacing(3), height: theme.spacing(3), color: theme.palette.warning.main }} />}
              caption={'1 Blocker, 1 Critical, 1 High, 1 Medium, 1 Low'}
            />*/}
          </Stack>

          <NRLicenseDetails license={license} />
          <NRDrawerTile total={license?.additionalCounts?.issues} title={'Issues'} handleTotalClick={handleTotalIssuesClick} />
          <NRDrawerTile
            total={license?.additionalCounts?.associatedComponents}
            title={'Associated Components'}
            handleTotalClick={handleTotalComponentsClick}
          />
        </Box>
      )}
      {!!isLoading && (
        <Box display="flex" alignItems={'center'} justifyContent={'center'} height={'100%'}>
          <CircularProgress sx={{ marginLeft: '8px' }} color={'primary'} size={20} />
        </Box>
      )}
    </Box>
  );
}

export default NRLicenseDrawerContainer;
